(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-device-grid"] && !Shopify.designMode) return;
  try {
    
  class NwDeviceGrid {
    constructor(root) {
      this.root = root;
      this.input = root.querySelector('[data-nw-device-search]');
      this.clearButton = root.querySelector('[data-nw-device-clear]');
      this.status = root.querySelector('[data-nw-device-status]');
      this.empty = root.querySelector('[data-nw-device-empty]');
      this.queryLabel = root.querySelector('[data-nw-device-query]');
      this.groups = Array.from(root.querySelectorAll('[data-nw-device-group]'));

      // Index every tile once so a keystroke only compares pre-built strings.
      this.tiles = Array.from(root.querySelectorAll('.item')).map((element) => {
        const label = element.querySelector('span')?.textContent || '';
        const link = element.querySelector('a')?.getAttribute('href') || '';
        const alt = element.querySelector('img')?.getAttribute('alt') || '';
        const haystack = NwDeviceGrid.normalize(label + ' ' + alt + ' ' + link);

        return { element, haystack, squashed: haystack.replace(/ /g, '') };
      });

      this.deferOffscreenImages();

      if (!this.input) return;

      this.input.addEventListener('input', () => this.filter(this.input.value));
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          this.clear();
        }
      });
      this.clearButton?.addEventListener('click', () => this.clear());

      // A browser-restored value (back button, bfcache) needs applying on load.
      if (this.input.value) this.filter(this.input.value);
    }

    static normalize(value) {
      return value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    clear() {
      this.input.value = '';
      this.filter('');
      this.input.focus();
    }

    filter(rawQuery) {
      const query = NwDeviceGrid.normalize(rawQuery);
      const terms = query ? query.split(' ') : [];
      const squashed = query.replace(/ /g, '');
      let matches = 0;

      for (const tile of this.tiles) {
        // "iphone 15 pro" matches on every term; "iphone15pro" matches squashed.
        const isMatch =
          terms.length === 0 ||
          terms.every((term) => tile.haystack.includes(term)) ||
          tile.squashed.includes(squashed);

        tile.element.hidden = !isMatch;
        if (isMatch) matches += 1;
      }

      // A heading left standing over an empty grid reads as a broken section.
      for (const group of this.groups) {
        group.hidden = !group.querySelector('.item:not([hidden])');
      }

      if (this.clearButton) this.clearButton.hidden = rawQuery.length === 0;

      if (this.empty) {
        this.empty.hidden = matches > 0 || terms.length === 0;
        if (this.queryLabel) this.queryLabel.textContent = rawQuery.trim();
      }

      if (this.status) {
        this.status.textContent =
          terms.length === 0 ? '' : matches + (matches === 1 ? ' device found' : ' devices found');
      }
    }

    deferOffscreenImages() {
      // These lists ship 100+ images; anything the browser has not already
      // started fetching can wait until it scrolls into view.
      for (const tile of this.tiles) {
        const image = tile.element.querySelector('img');
        if (!image || image.hasAttribute('loading') || image.complete) continue;
        image.setAttribute('loading', 'lazy');
        image.setAttribute('decoding', 'async');
      }
    }
  }

  function initNwDeviceGrids(scope) {
    const roots = (scope || document).querySelectorAll('[data-nw-device-grid]');
    for (const root of roots) {
      if (root.dataset.nwDeviceGridReady === 'true') continue;
      root.dataset.nwDeviceGridReady = 'true';
      new NwDeviceGrid(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initNwDeviceGrids());
  } else {
    initNwDeviceGrids();
  }

  document.addEventListener('shopify:section:load', (event) => initNwDeviceGrids(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-header"]) return;
  try {
    
  // Opens the nav dropdowns on hover, on top of the plain click-to-toggle
  // every <details> already does natively. Hover used to be gated behind
  // matchMedia('(hover: hover) and (pointer: fine)'), meant to keep a tap on
  // touch from being misread as hover - but everything in .nw-header__nav is
  // already hidden below 990px (touch phones get the mobile drawer's own,
  // separate finder instead), so nothing here is ever reachable by a tap in
  // the first place, and the gate was just silently disabling hover-to-open
  // wherever matchMedia didn't report a fine pointer, including at least one
  // desktop testing setup. Hover is unconditional now.
  //
  // "Close the other ones" used to live inside that same gate, so clicking a
  // second dropdown where matchMedia failed just opened it alongside the
  // first with nothing to close it. Moved onto 'toggle', which <details>
  // fires however it was opened (click or the mouseenter below setting
  // .open), so closing siblings works the same regardless of how this got
  // opened.
  function nwHeaderHoverInit() {
    const dropdowns = document.querySelectorAll('.nw-header__dropdown');
    let closeTimer = null;

    const closeAll = (except) => {
      for (const other of dropdowns) {
        if (other !== except) other.open = false;
      }
    };

    for (const dropdown of dropdowns) {
      if (dropdown.dataset.nwHoverReady === 'true') continue;
      dropdown.dataset.nwHoverReady = 'true';

      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) closeAll(dropdown);
      });

      dropdown.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        dropdown.open = true;
      });

      // A short grace period: without it, clipping the edge of the trigger
      // on the way to the submenu snaps the menu shut.
      //
      // Not while one of its selects is in use: a native select's option
      // list opens outside the panel, so picking a model left the pointer
      // outside it and shut the device finder before the category step. It
      // stays open until a category is picked (which navigates), a click
      // lands outside it, or Escape.
      dropdown.addEventListener('mouseleave', () => {
        clearTimeout(closeTimer);
        if (dropdown.contains(document.activeElement) && document.activeElement.matches('select')) return;
        closeTimer = setTimeout(() => {
          dropdown.open = false;
        }, 180);
      });

      // Following a link should not leave the menu hanging open behind it.
      dropdown.addEventListener('click', (event) => {
        if (event.target.closest('a')) dropdown.open = false;
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll(null);
    });

    // The way out for a dropdown kept open by a focused select (see
    // mouseleave above).
    document.addEventListener('click', (event) => {
      for (const dropdown of dropdowns) {
        if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
      }
    });
  }

  // The drawer is position: fixed, so its offset is measured from the top of
  // the viewport - not from the header. offsetHeight gave the header's own
  // height and ignored the announcement bar above it, so the drawer opened
  // partway up the header and the backdrop dimmed it. getBoundingClientRect()
  // .bottom is the distance to the bottom of the header, which is the offset
  // actually wanted.
  function nwHeaderMeasure() {
    const header = document.querySelector('.nw-header');
    if (!header) return;

    const apply = () => {
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      header.style.setProperty('--nw-header-h', bottom + 'px');
    };
    apply();

    if (!header.dataset.nwMeasureReady) {
      header.dataset.nwMeasureReady = 'true';
      window.addEventListener('resize', apply, { passive: true });
      // Re-measured on open too: a sticky header's distance from the top of
      // the viewport changes as the page scrolls.
      document.querySelector('.nw-header__mobile-toggle')?.addEventListener('toggle', apply);
    }
  }

  function nwHeaderInit() {
    nwHeaderHoverInit();
    nwHeaderMeasure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nwHeaderInit);
  } else {
    nwHeaderInit();
  }

  document.addEventListener('shopify:section:load', nwHeaderInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-trending"] && !Shopify.designMode) return;
  try {
    
  // Scoped entirely to this section's own markup, so it can never attach to
  // the wrong row - the fault that broke every previous attempt at this.
  function nwTrendInit(root) {
    const rows = (root || document).querySelectorAll('[data-nw-trend-row]');

    for (const row of rows) {
      if (row.dataset.nwTrendReady === 'true') continue;
      row.dataset.nwTrendReady = 'true';

      const wrap = row.closest('.nw-trend__viewport');
      const prev = wrap?.querySelector('[data-nw-trend-prev]');
      const next = wrap?.querySelector('[data-nw-trend-next]');
      if (!prev || !next) continue;

      const step = (dir) => {
        const card = row.firstElementChild;
        const amount = card ? card.getBoundingClientRect().width + 16 : row.clientWidth * 0.8;
        row.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };

      const sync = () => {
        prev.disabled = row.scrollLeft <= 4;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      };

      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      row.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => nwTrendInit());
  } else {
    nwTrendInit();
  }

  document.addEventListener('shopify:section:load', (event) => nwTrendInit(event.target));

  } catch(e) { console.error(e); }
})();
})();
